import React from 'react';
import classnames from 'classnames';

import { Image } from 'components/ui';
import * as ProductHelpers from 'helpers/ProductHelpers';

import { ProductPrice } from '../parts';

import ProductDetailsActions from './ProductDetailsActions';

import type {
  IAnalyticsListProps,
  IProductDetails,
  IProductVariant
} from 'types';

import styles from './ProductDetailsToolbar.module.scss';

interface Props {
  isVisible: boolean,
  //
  product: IProductDetails,
  variant: IProductVariant,
  listProps: IAnalyticsListProps,
  //
  currency: string,
  originalPrice?: number,
  price: number,
  priceColor?: string,
  priceIcon?: string,
  //
  onSimilarClick: (e: React.MouseEvent<HTMLButtonElement>) => void
}

const ProductDetailsToolbar = (props: Props) => {

  const {
    isVisible,
    //
    product,
    variant,
    listProps,
    //
    currency,
    originalPrice,
    price,
    priceColor,
    priceIcon,
    //
    onSimilarClick,
  } = props;

  // Props

  const {
    name,
    image
  } = product || {};

  // Render

  return (
    <div
      className={classnames(styles.root, { [styles.collapsed]: !isVisible })}
    >
      <div className={styles.inner}>

        {/* Left */}
        <div className={styles.left}>

          {/* Thumbnail */}
          <div className={styles.thumbnail}>
            <Image
              src={ProductHelpers.getThumbnailSrc(image)}
              width={48}
              height={48}
              alt={name}
            />
          </div>

          {/* Image */}
          <div className={styles.name}>
            {name}
          </div>

        </div>

        {/* Right */}
        <div className={styles.right}>

          {/* Price */}
          <ProductPrice
            className={styles.priceContainer}
            originalPriceClassName={styles.originalPrice}
            priceClassName={styles.price}
            //
            currency={currency}
            originalPrice={originalPrice}
            price={price}
            //
            inlineReverse
            //
            color={priceColor}
            icon={priceIcon}
          />

          {/* Actions */}
          <ProductDetailsActions
            className={styles.actions}
            //
            product={product}
            variant={variant}
            listProps={listProps}
            //
            onSimilarClick={onSimilarClick}
          />

        </div>
      </div>
    </div>
  );
};

export default React.memo(ProductDetailsToolbar);
